import { render, staticRenderFns } from "./PDPAccordion.vue?vue&type=template&id=14924529&scoped=true"
import script from "./PDPAccordion.vue?vue&type=script&lang=js"
export * from "./PDPAccordion.vue?vue&type=script&lang=js"
import style0 from "./PDPAccordion.vue?vue&type=style&index=0&id=14924529&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14924529",
  null
  
)

export default component.exports